const checklist = [
  'Rendimentos de salários e pró-labore',
  'Aluguéis e rendimentos de aplicações',
  'Bens e direitos (imóveis, veículos)',
  'Dependentes e deduções legais',
  'Despesas médicas e educacionais',
  'Previdência privada (PGBL/VGBL)',
];

export default function FolderIRPF() {
  return (
    <div
      className="relative overflow-hidden flex flex-col"
      style={{
        width: '390px',
        height: '693px',
        background: 'linear-gradient(175deg, #1a0a00 0%, #2d1500 40%, #3d1f00 100%)',
      }}
    >
      {/* Texture overlay */}
      <div
        className="absolute inset-0 opacity-8 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/57465ac15a1cde1bfedeb2d1beb60be3.jpg')",
        }}
      />

      {/* Gold top bar */}
      <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#f0d060] to-[#c9a84c]" />
      {/* Gold bottom bar */}
      <div className="absolute bottom-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#f0d060] to-[#c9a84c]" />

      {/* Decorative diagonal line */}
      <div className="absolute top-0 right-16 w-px h-full bg-gradient-to-b from-[#c9a84c]/30 via-[#c9a84c]/10 to-transparent" />

      <div className="relative z-10 flex flex-col h-full px-8 py-7">
        {/* Header */}
        <div className="flex items-start justify-between mb-5">
          <div>
            <div className="text-[#c9a84c] font-bold text-2xl tracking-tight" style={{ fontFamily: 'Georgia, serif' }}>RCP</div>
            <div className="text-white/50 text-[8px] font-bold tracking-[0.18em] uppercase mt-0.5">Inteligência Contábil &amp; Tributária</div>
          </div>
          <div className="bg-[#c9a84c] rounded-md px-2.5 py-1.5 text-center">
            <div className="text-[#2d1500] font-bold text-[9px] uppercase tracking-wide">IRPF</div>
            <div className="text-[#2d1500]/70 text-[7px]">2025</div>
          </div>
        </div>

        {/* Hero image */}
        <div className="rounded-xl overflow-hidden mb-5" style={{ height: '145px', flexShrink: 0 }}>
          <img
            src="https://readdy.ai/api/search-image?query=person%20filling%20tax%20return%20form%20at%20desk%20with%20laptop%20calculator%20financial%20documents%20receipts%20organized%20papers%20warm%20office%20lighting%20professional%20accountant%20helping%20client%20income%20tax%20declaration%20brazil&width=1080&height=560&seq=folder-irpf-01&orientation=landscape"
            alt="Declaração de IRPF RCP"
            className="w-full h-full object-cover object-center"
          />
          <div
            className="rounded-xl"
            style={{
              position: 'relative',
              marginTop: '-145px',
              height: '145px',
              background: 'linear-gradient(to top, rgba(45,21,0,0.7) 0%, transparent 60%)',
            }}
          />
        </div>

        {/* Headline */}
        <div className="mb-4">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-5 h-px bg-[#c9a84c]" />
            <span className="text-[#c9a84c] text-[9px] font-bold tracking-[0.2em] uppercase">Declaração de Imposto de Renda</span>
          </div>
          <h2 className="text-white font-bold leading-tight" style={{ fontSize: '20px', fontFamily: 'Georgia, serif' }}>
            Declare seu IR com<br />
            <span className="text-[#c9a84c]">segurança e sem erros.</span>
          </h2>
          <p className="text-white/50 text-[10px] leading-relaxed mt-2">
            Evite a malha fina e maximize suas restituições com a assessoria especializada da RCP.
          </p>
        </div>

        {/* Checklist */}
        <div className="mb-4">
          <div className="text-[#c9a84c] text-[9px] font-bold tracking-[0.2em] uppercase mb-2.5">O que declaramos por você</div>
          <div className="space-y-1.5">
            {checklist.map((item) => (
              <div key={item} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center bg-[#c9a84c]/20 border border-[#c9a84c]/40 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-[#c9a84c] text-[8px]" />
                </div>
                <span className="text-white/65 text-[9px]">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Alert box */}
        <div className="bg-[#c9a84c]/10 border border-[#c9a84c]/30 rounded-lg px-4 py-2.5 flex items-center gap-3 mb-4">
          <div className="w-6 h-6 flex items-center justify-center text-[#c9a84c] flex-shrink-0">
            <i className="ri-alarm-warning-line text-base" />
          </div>
          <p className="text-white/70 text-[9px] leading-relaxed">
            <strong className="text-[#c9a84c]">Prazo:</strong> Não deixe para a última hora. Agende agora e evite multas e juros.
          </p>
        </div>

        {/* CTA */}
        <div className="mt-auto">
          <div className="bg-[#c9a84c] rounded-xl px-5 py-3 flex items-center justify-between mb-3">
            <div>
              <div className="text-[#2d1500] font-bold text-[11px] uppercase tracking-wide">Agende sua declaração</div>
              <div className="text-[#2d1500]/65 text-[9px] mt-0.5">Atendimento personalizado</div>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-6 h-6 flex items-center justify-center bg-[#2d1500] rounded-full">
                <i className="ri-whatsapp-line text-[#c9a84c] text-xs" />
              </div>
              <span className="text-[#2d1500] font-bold text-[10px]">(51) 99100-3410</span>
            </div>
          </div>

          <div className="w-full h-px bg-gradient-to-r from-[#c9a84c]/30 to-transparent mb-2" />
          <div className="flex items-center justify-between">
            <span className="text-white/30 text-[8px]">@inteligenciarcp · rcpinteligencia.com.br</span>
            <span className="text-[#c9a84c]/40 text-[7px] font-semibold uppercase tracking-widest">CRC RS 011307/O-2</span>
          </div>
        </div>
      </div>
    </div>
  );
}
